import { Component, HostListener } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { CommonService } from 'src/@services/common.service';
import { AuthServiceService } from './auth-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],

  standalone: false,
})
export class AppComponent {
  title = 'brooklyn';
  isVisibleIdleModal: boolean = false;
  subscription: any;
  userActivity: any;
  userInactive: Subject<any> = new Subject();
  currentUrl: string;

  constructor(private router: Router, public _cS: CommonService, private authService: AuthServiceService) {
    this.router.events.subscribe((event: any) => {
      if (event instanceof NavigationEnd) {
        this.currentUrl = event.url;
      }
    });
    this.SetTimeoutFirst10();
    this.userInactive.subscribe(() => {
      _cS.logOut();
    });
  }

  stayLoggedIn() {
    this.isVisibleIdleModal = false;
  }

  // to show modal after 27 minutes of inactivity
  SetTimeoutShowModal() {
    if (
      this.currentUrl &&
      (this.currentUrl.includes('login') ||
        this.currentUrl.includes('reset-password') ||
        this.currentUrl.includes('forgot-password') ||
        this.currentUrl.includes('verify-user') ||
        this.currentUrl.includes('activation') ||
        this.currentUrl.includes('mobile-verify') ||
        this.currentUrl.includes('setup-passkey') ||
        this.currentUrl == '/')
    ) {
      this.isVisibleIdleModal = false;
    } else {
      // this will get excuted after 27 minutes of inactivity
      this.userActivity = setTimeout(() => {
        this.isVisibleIdleModal = true;
        this.SetTimeoutFinal();
      }, 6300000);
    }
  }
  // to logout after 30 minutes of inactivity
  SetTimeoutFinal() {
    // this will get excuted after 3 minutes of modal visibility
    this.userActivity = setTimeout(() => {
      this.isVisibleIdleModal = false;
      this.userInactive.next(undefined);
      this._cS.logOut();
    }, 900000);
  }

  SetTimeoutFirst10() {
    //gets executed when there's user inactive time of 10 seconds
    this.userActivity = setTimeout(() => {
      this.SetTimeoutShowModal();
    }, 10000);
  }
  @HostListener('keypress', ['$event'])
  @HostListener('window:mousemove', ['$event'])
  refreshUserState() {
    if (!this.isVisibleIdleModal) {
      clearTimeout(this.userActivity);
      this.SetTimeoutFirst10();
    }
  }
  ngOnInit() {
  // if (this.authService.isTokenValid()) {
  //       this.authService.scheduleAutoLogout();
  //     } else {
  //       this.authService.logout(); // expired at load → kick user
  //     }  
}
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
